import { ChangeEvent } from "react";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { FormControlModel } from "types";
import { useField } from "formik";
import get from "lodash/get";
import ErrorMessage from "ui/atoms/ErrorMessage";

const RadioGroupForm = ({ questionData, name, visible, label, formik, onChangeCallback }: FormControlModel) => {
  const [field, meta] = useField(name);
  if (!questionData) return <></>;
  return visible ? (
    <Box sx={{ display: "flex" }}>
      <FormControl
        sx={{ marginTop: "1rem" }}
        error={meta.touched && !field?.value?.value && Boolean(get(meta.error, "value"))}
        required
      >
        <FormLabel id='demo-controlled-radio-buttons-group'>{label}</FormLabel>
        <RadioGroup
          row
          name={name}
          onChange={({ target }: ChangeEvent<HTMLInputElement>) => {
            const value = target?.value.toString();
            onChangeCallback && onChangeCallback(value as string);
            formik.setFieldValue(name, {
              value,
              questionID: questionData?.id,
            });
          }}
          value={formik.values[name]?.value || ""}
          aria-labelledby='demo-controlled-radio-buttons-group'
        >
          {questionData?.source?.map((item: any) => (
            <FormControlLabel key={item?.value} value={item?.value} control={<Radio />} label={item?.descripcion} />
          ))}
        </RadioGroup>
        <ErrorMessage>{meta.touched && get(meta.error, "value")}</ErrorMessage>
      </FormControl>
    </Box>
  ) : null;
};

export default RadioGroupForm;
